import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/personal-website/personal-website/components/QuoteBlock/QuoteBlock.tsx");
